/**
 * Parse `any` content and return the "best possible" html tag
 *
 * + If `any` looks like HTML, it will return `any`
 * + If `any` is a URL ending in `.js`, it returns a `<script>` tag
 * + If `any` is a URL, it returns an `<iframe>` tag
 *
 * @param  {string} any HTML or URL
 * @return {[type]}     [description]
 */
module.exports.htmlOrScriptOrIframeTagFromString = function (any) {
  const cxfFullscreen = 'position: absolute;left: 0;right: 0;top: 0; bottom: 0;border: none;width: 100%;height: 100%;'
  const randomId = () => Math.random().toString(36).substr(2)
  const isHtml = Boolean(any.match(/^\s*</))
  const isJs = !isHtml && any.endsWith('.js')
  const elementId = randomId()
  const appendQueryParam = (url, param) => [
    url,
    url.match(/\?/) ? '&' : '?',
    param
  ].join('')

  const url = !isHtml && appendQueryParam(any, `elementId=${elementId}`)

  const htmlTag =
        isHtml ? any : isJs ?
          (`<script id="${elementId}" src="${url}"><${'/script>'}`) :
          (`<iframe id="${elementId}" style="${cxfFullscreen}" src="${url}"></iframe>`)
  return htmlTag
}

module.exports.isGameIntegrationPage = function () {
  return Boolean(window.ggsCore)
}
